<div class="flex" style="margin-top: 15px;" *ngIf="decoders && decoders.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="decoders"
        [totalRecords]="totalDecoders"
        [responsive]="true"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onPage)="onPageChange($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'attribute.name' | transloco}}</th>
            <th>{{'attribute.type' | transloco}}</th>
            <th>{{'attribute.createdAt' | transloco}}</th>
            <th>{{'attribute.updatedAt' | transloco}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-decoder>
          <tr *ngIf="!loadingDecoders">
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              {{decoder.name}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.type' | transloco}}</span>
              {{decoder.type}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.createdAt' | transloco}}</span>
              {{decoder.creationDate | customDate}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.updatedAt' | transloco}}</span>
              {{decoder.updatedDate | customDate}}
            </td>
          </tr>
          <tr *ngIf="loadingDecoders">
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalDecoders == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalDecoders > 0">
            Showing {{first+1}}
            to {{(first+rows) >= totalDecoders ? totalDecoders : (first+rows)}}
            of {{totalDecoders}} {{totalDecoders > 1 ? 'entries':'entry'}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="decoders && decoders.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.decoders' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!decoders">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
